import { Button, Group, Modal, Stack, SegmentedControl } from "@mantine/core";
import { useForm } from "react-hook-form";
import { TextInput } from "react-hook-form-mantine";
import { IconWorld, IconUpload } from "@tabler/icons-react";
import { useState } from "react";
import { web_sessionLinkSchema } from "@congrs/schemas";
import resolver from "@congrs/resolver";

import PDFUpload from "../../PDFUpload";

export default function AddLinkModal({ opened, onClose, onSubmit }) {
  const [activeTab, setActiveTab] = useState("url");

  const linkForm = useForm({
    defaultValues: {
      title: "",
      url: null,
      fileKey: null,
    },
    resolver: resolver(web_sessionLinkSchema),
  });

  const handleSubmit = (data) => {
    const linkData = {
      title: data.title,
      ...(activeTab === "url" ? { url: data.url } : { fileKey: data.fileKey }),
    };
    onSubmit(linkData);
    linkForm.reset();
  };

  return (
    <Modal
      opened={opened}
      onClose={() => {
        onClose();
        linkForm.reset();
      }}
      title="Add New Link"
      size="md"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          linkForm.handleSubmit(handleSubmit)(e);
        }}
      >
        <Stack gap="md">
          <TextInput
            label="Link Title"
            placeholder="Enter link title"
            name="title"
            control={linkForm.control}
            withAsterisk
            size="sm"
          />

          <SegmentedControl
            value={activeTab}
            onChange={setActiveTab}
            data={[
              {
                label: "URL",
                value: "url",
                leftSection: <IconWorld size={16} />,
              },
              {
                label: "File Upload",
                value: "file",
                leftSection: <IconUpload size={16} />,
              },
            ]}
            fullWidth
          />

          {activeTab === "url" ? (
            <TextInput
              label="URL"
              placeholder="Enter URL"
              name="url"
              control={linkForm.control}
              withAsterisk
              size="sm"
            />
          ) : (
            <PDFUpload
              control={linkForm.control}
              name="fileKey"
              label="Upload File (PDF)"
            />
          )}

          <Group justify="flex-end" mt="md">
            <Button
              variant="light"
              onClick={() => {
                onClose();
                linkForm.reset();
              }}
              size="sm"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              size="sm"
              disabled={!linkForm.formState.isValid}
            >
              Add Link
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
}
